<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('FlatChannelTool', function() {
            return {
                group: 'Lines', category: 'Channels', icon: 'channel.svg',
                name: 'Flat Top/Bottom',
                type: 'FlatChannel',
                hint: 'Flat Top/Bottom Channel',
                data: [],
                settings: {}
            }
        }, 'Flat Top/Bottom')
</script>
